import Collection from "../../../../../../../assets/icon/svg/cards/collection";
import Document from "../../../../../../../assets/icon/svg/cards/document";
import Image from "../../../../../../../assets/icon/svg/cards/image";
import Product from "../../../../../../../assets/icon/svg/cards/product";
import { PREVIEW } from "../../../constants/preview";

export const CARDS = [
   {
      icon: <Document />,
      name: "+ Văn bản",
      value: {
         type: PREVIEW.TEXT,
         title: "",
         buttons: [

         ]
      }
   },
   {
      icon: <Image />,
      name: "+ Hình ảnh",
      value: {
         type: PREVIEW.IMAGE,
         title: "",
         image: {
            image_url: "",
            attachment_id: "",
            action_type: 0
         }
      }
   },
   {
      icon: <Collection />,
      name: "+ Bộ sưu tập",
      value: {
         type: PREVIEW.GALLERY,
         buttons: [],
         images: [{
            title: "",
            sub_title: "",
            image_url: "",
            buttons: [],
            action_type: 0
         }]
      }
   },
   // {
   //    icon: <Product />,
   //    name: "+ Sản phẩm"
   // }
]